import { useMutation, useQueryClient } from 'react-query'

import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { scanToEarnService } from 'src/services/scan-to-earn.service'

import { IScanToEarnCreateDto } from 'src/types'

export const useCreateConsumerScan = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: IScanToEarnCreateDto) => {
      const mediaWithText = dto.media.map((mediaItem, index) => ({
        ...mediaItem,
        title: `${dto.barcode_id}_${index}`,
      }))

      const uploadedMedia = await mediaEntityUploadService.uploadMedia(mediaWithText, false)

      return scanToEarnService.createConsumerScan({
        ...dto,
        media: uploadedMedia,
      })
    },
    {
      onSuccess(data) {
        if (!data) {
          return
        }
      },
    },
  )
}
